import React from 'react';

const TrendChart = ({ title, data, formatDate }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="space-y-3">
        {data.map((point, index) => (
          <div key={index} className="flex items-center space-x-3">
            <div className="text-sm text-gray-600 w-16">{formatDate(point.date)}</div>
            <div className="flex-1 bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-500 h-2 rounded-full" 
                style={{ width: `${(point.value / 10) * 100}%` }}
              ></div>
            </div>
            <div className="text-sm font-medium text-gray-900 w-8">{point.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendChart;
